import { render, staticRenderFns } from "./saleBody.vue?vue&type=template&id=5bada5f9"
import script from "./saleBody.vue?vue&type=script&lang=js"
export * from "./saleBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports